import { useCallback } from "react";
import { useCurrentAccountId } from "@zapier/identity";
import emitUserInteractionEvent, {
  UserInteractionName,
} from "./emitUserInteractionEvent";

export type TableKebabInteractionOption =
  | "change_owner"
  | "delete"
  | "rename"
  | "share"
  | "share_table"
  | "duplicate";

export function useEmitTableKebabInteractionEvent() {
  const accountId = useCurrentAccountId();

  const emit = useCallback(
    (optionSelected: TableKebabInteractionOption, tableId?: string) => {
      emitUserInteractionEvent({
        accountId,
        interactionName: UserInteractionName.TableKebab,
        optionSelected,
        customTrackingFields: {
          table_id: tableId,
        },
      });
    },
    [accountId],
  );

  return {
    emit,
  };
}
